import React, { FC } from 'react'
import { Facet } from 'transfix-ui/components/Facet'
import {
  IFilterAutocompleteProp,
  isAutosuggestResult,
} from 'transfix-ui/components/FilterAutocomplete'
import Box from 'transfix-ui/core/Box'
import { NormFileGeneratorStatusFilters } from 'apps/marketplace/apiTypes/normFileGeneratorStatuses'
import AdminFilterAutocomplete from 'apps/marketplace/components/AdminFilterAutocomplete'
import { UserIcon } from 'transfix-icons'
import { StatusFilter } from './StatusFilter'

interface INormingJobsFiltersProps {
  filters?: NormFileGeneratorStatusFilters
  setFilters: (filters: Partial<NormFileGeneratorStatusFilters>) => void
}

export const NormingJobsFilters: FC<INormingJobsFiltersProps> = ({
  filters = {},
  setFilters,
}: INormingJobsFiltersProps) => {
  const { statuses } = filters
  const onStatusesChange = (selectedStatuses: string[]) =>
    setFilters({
      statuses: selectedStatuses,
    })
  const onAdminChange = (val: IFilterAutocompleteProp) => {
    if (isAutosuggestResult(val)) {
      setFilters({
        userId: Number(val.id),
      })
    } else if (val === null) {
      setFilters({
        userId: undefined,
      })
    }
  }
  const onCurrentUserSelect = (isSelected: boolean) =>
    setFilters({
      currentUser: isSelected || undefined,
    })

  return (
    <Box display='flex' alignItems='flex-end'>
      <Box width='auto'>
        <StatusFilter statuses={statuses} onSelect={onStatusesChange} />
      </Box>
      <Box width='auto' ml={2}>
        <Facet
          id='currentUser'
          dataTest='current-user-filter'
          label='Created by Me'
          icon={<UserIcon size='large' />}
          onClick={onCurrentUserSelect}
          selected={!!filters.currentUser}
          isLoading={false}
        />
      </Box>
      <Box width='auto' ml={2}>
        <AdminFilterAutocomplete label='Creator' onSelectedValue={onAdminChange} />
      </Box>
    </Box>
  )
}
